<template>
    <div>
        <el-carousel :height="computeHeight">
            <el-carousel-item v-for="(item, index) in sliders" :key="index">
                <img :src="item.img" class="slider_img">
            </el-carousel-item>
        </el-carousel>

        <section style="width:100%;padding:6vw 0;box-sizing:border-box;display:flex;flex-flow:column nowrap;justify-content:center;align-items:center;">
            <!-- 公司简介 -->
            <img :src="require('../../static/公司简介.jpg')" style="width:80vw;max-width:600px;height:auto;margin-bottom:4vw;"/>
            <template v-if="seen">
                <div>
                    <el-row :gutter="20" style="background: #F8F8F8;padding:0 8vw;">
                        <el-col :xs="12" :sm="12" :md="12" style="position:relative;">
                            <img :src="require('../../static/111.png')" style="width:100%;height:auto;position:absolute;top:-3vw;left:0;"/>
                        </el-col>
                        <el-col :offset="12" :xs="12" :sm="12" :md="12" style="height:30vw;padding-top:4vw;display:flex;flex-flow:column nowrap;align-content:center;align-items:center;">
                            <p style="font-family: HarmonyOS Sans SC, HarmonyOS Sans SC; font-weight: 'bold'; font-size: 2vw; color: #1A1A1A; line-height: 3vw">名楊科技（My Technolog(HK) Limited）<br>2022年成立於香港</p>
                            <p style="font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;font-weight: 400;font-size: 1.5vw;color: #666666; line-height: 2.5vw;padding-left:1vw;">主要致力於提供个性化的信息技術廣告營銷一體化服務，同時也為客戶提供定制化的運營咨詢服務。公司團隊來自於互聯網頭部企業，有20+的行業經驗。公司重視客戶的感受，以提供優質的服務為先，追求創新與卓越。</p>
                        </el-col>
                    </el-row>
                </div>
            </template>
            <template v-else>
                <div>
                    <el-row :gutter="20" style="background: #F8F8F8;padding:0 8vw;margin-top:5vw;">
                        <el-col :xs="12" :sm="12" :md="12" style="position:relative;">
                            <img :src="require('../../static/111.png')" style="width:100%;height:auto;position:absolute;top:-5vw;left:0;"/>
                        </el-col>
                        <el-col :offset="12" :xs="12" :sm="12" :md="12" style="height:30vw;padding-top:5vw;display:flex;flex-flow:column nowrap;align-content:center;align-items:center;">
                            <p style="font-family: HarmonyOS Sans SC, HarmonyOS Sans SC; font-weight: 'bold'; font-size: 2vw; color: #1A1A1A; line-height: 3vw">名楊科技（My Technolog(HK) Limited）<br>2022年成立於香港</p>
                            <p style="font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;font-weight: 400; font-size: 1.5vw;color: #666666; line-height: 2.5vw;padding-left:1vw;">主要致力於提供个性化的信息技術廣告營銷一體化服務，同時也為客戶提供定制化的運營咨詢服務。公司團隊來自於互聯網頭部企業，有20+的行業經驗。公司重視客戶的感受，以提供優質的服務為先，追求創新與卓越。</p>
                        </el-col>
                    </el-row>
                </div>
            </template>
            
            <!-- 业务介绍 -->
            <img :src="require('../../static/业务介绍.jpg')" style="width:80vw;max-width:600px;height:auto;margin-bottom:2vh;margin-top:8vw;"/>
            <template v-if="seen">
                <div class="border_parent">
                    <el-row :gutter="20">
                        <el-col :xs="8" :sm="8" :md="8" v-for="(item,index) in list2" :key="index">
                            <div @mouseenter="active2=index" @mouseleave="active2=index" :class="['border', seen ? 'middle_li':'']" style="cursor: pointer;display:flex;flex-flow:column nowrap;justify-content:center;">
                                <img :src="item.img" style="width:100%;border-radius: 6px 6px 0 0;"/>
                                <div class="border_img_parent" style="height:24vw;display:flex;flex-flow:column nowrap;justify-content:center;align-items:flex-start;padding:2vw 2vw;box-sizing:border-box;border-radius: 6px 6px 6px 6px;margin-top:-6px;z-index: 999;">
                                    <div style="font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;font-weight: 'bold';font-size: 2vw;color: #1A1A1A;line-height: 5vw;">{{item.title}}</div>
                                    <div style="font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;font-weight: 400;font-size: 1.5vw;color: #666666;line-height: 2.3vw;">{{item.content[0]}}</div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </template>
            <template v-else>
                <div class="border_parent">
                    <el-row :gutter="8" style="margin-top:-3vw;">
                        <el-col :xs="8" :sm="8" :md="8" v-for="(item,index) in list2" :key="index">
                            <div @mouseenter="active2=index" @mouseleave="active2=index" :class="['border', seen ? 'middle_li':'']" style="cursor: pointer;display:flex;flex-flow:column nowrap;justify-content:center;margin-bottom:2px;">
                                <img :src="item.img" style="width:100%;border-radius: 6px 6px 0 0;"/>
                                <div class="border_img_parent" style="height:24vw;display:flex;flex-flow:column nowrap;justify-content:center;align-items:flex-start;padding:2vw 2vw;border-radius: 6px 6px 6px 6px;margin-top:-6px;z-index: 999;">
                                    <div style="font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;font-weight: 'bold';font-size: 2vw;color: #1A1A1A;line-height: 5vw;">{{item.title}}</div>
                                    <div style="font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;font-weight: 400;font-size: 1.5vw;color: #666666;line-height: 2.3vw;">{{item.content[0]}}</div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </template>

            <!-- 企业文化 -->
            <img :src="require('../../static/企业文化.jpg')" style="width:80vw;max-width:600px;height:auto;margin-bottom:2vh;margin-top:5vw;"/>
            <template v-if="seen">
                <div class="border_parent">
                    <el-row :gutter="0">
                        <el-col :xs="12" :sm="12" :md="12" v-for="(item,index) in list1" :key="index">
                            <div @mouseenter="active1=index" @mouseleave="active1=null" :class="['border', seen ? 'bg-blue':'']" style="cursor: pointer;padding:3vw;box-sizing:border-box;height:100%;display:flex;flex-flow:row nowrap;justify-content:center;align-items:center;border-radius:15px;">
                                <img :src="item.img" style="width:30%;"/>
                                <div class="border_img_parent" style="height:18vw;display:flex;flex-flow:column nowrap;justify-content:center;align-items:flex-start;border-radius: 6px 6px 6px 6px;margin-top:-6px;z-index: 999;">
                                    <div :style="{'fontFamily': 'HarmonyOS Sans SC, HarmonyOS Sans SC',fontWeight: 'bold',fontSize: '2vw',color: active1==index?'#fff':'#1A1A1A',lineHeight: '5vw',}">{{item.title}}</div>
                                    <div :style="{'fontFamily': 'HarmonyOS Sans SC, HarmonyOS Sans SC',fontWeight: 400,fontSize: '1.5vw',color: active1==index?'#fff':'#666666',lineHeight: '2.3vw',}">{{item.content[0]}}</div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </template>
            <template v-else>
                <div class="border_parent">
                    <el-row :gutter="8" style="margin-top:-3vw;">
                        <el-col :xs="12" :sm="12" :md="12" v-for="(item,index) in list1" :key="index">
                            <div @mouseenter="active1=index" @mouseleave="active1=null" :class="['border', seen ? 'bg-blue':'']" style="cursor: pointer;padding:3vw;box-sizing:border-box;height:100%;display:flex;flex-flow:row nowrap;justify-content:center;align-items:center;border-radius:15px;">
                                <img :src="item.img" style="width:30%;"/>
                                <div class="border_img_parent" style="height:18vw;display:flex;flex-flow:column nowrap;justify-content:center;align-items:flex-start;border-radius: 6px 6px 6px 6px;margin-top:-6px;z-index: 999;">
                                    <div :style="{'fontFamily': 'HarmonyOS Sans SC, HarmonyOS Sans SC',fontWeight: 'bold',fontSize: '2vw',color: active1==index?'#fff':'#1A1A1A',lineHeight: '5vw',}">{{item.title}}</div>
                                    <div :style="{'fontFamily': 'HarmonyOS Sans SC, HarmonyOS Sans SC',fontWeight: 400,fontSize: '1.5vw',color: active1==index?'#fff':'#666666',lineHeight: '2.3vw',}">{{item.content[0]}}</div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </template>
        </section>
        
    </div>
</template>
<script>
    export default {
        name: 'Index',
        data() {
            return {
                active1: null,
                active2: 0,
                sliders: [],
                list1: [
                    {
                        img: require('../../static/331.png'),
                        title: "合作與共贏",
                        content: ["我們重視合作與共贏的精神，與客戶、合作夥伴以及團隊內部緊密合作，攜手共進，共同實現成功。"]
                    },
                    {
                        img: require('../../static/332.png'),
                        title: "創新與卓越",
                        content: ["我們鼓勵員工不斷創新和追求卓越，相信通過不斷推陳出新，勇於嘗試新的想法和方法。"]
                    },
                    {
                        img: require('../../static/333.png'),
                        title: "誠信與責任",
                        content: ["我們堅守誠信和責任的原則，以誠信為基石，以高度的責任心對待客戶、合作夥伴和員工，承諾做到言行一致，履行承諾，幷對自己的行為負責。"]
                    },
                    {
                        img: require('../../static/334.png'),
                        title: "學習與成長",
                        content: ["我們鼓勵員工持續學習和个人成長，提供良好的學習和發展機會，支持員工不斷提昇技能和知識水平，相信通過學習和成長，我們能够更好地滿足客戶需求，幷為公司的發展做出貢獻。"]
                    },
                ],
                list2: [
                    {
                        index: 0,
                        img: require('../../static/221.png'),
                        title: "運營管理咨詢",
                        content: ["我們的專業團隊通過深入分析客戶的運營和管理問題，提供全面的解決方案和建議，為客戶量身定制包括但不限於運營流程優化、成本控制、人才培養等咨詢服務，幫助客戶提高競爭力和創新力。"]
                    },
                    {
                        index: 1,
                        img: require('../../static/222.png'),
                        title: "廣告營銷一體化",
                        content: ["我們通過網絡媒介例如谷歌、Facebook等平臺，為客戶的産品或服務進行宣傳推廣，提供定制化創意服務，幫助客戶打造數字化品牌形象，幷提供整體運營方案，旨在幫助客戶提昇品牌力，擴大市場份額和提高銷售額。"]
                    },
                    {
                        index: 2,
                        img: require('../../static/223.png'),
                        title: "信息技術服務",
                        content: ["我們為客戶提供定制化的信息技術服務，包括咨詢、運行維護、功能測試和接口測試等，根據客戶的需求和業務特點，提供相關的解決方案，幫助他們獲取相關的收益，致力於通過信息技術的應用，提昇客戶的業務效率和競爭力。"]
                    }
                ],
                carousel_height: '47vw',
                seen: true
            }
        },
        methods: {
            menuSeen(){
                // 屏幕尺寸
                let screenHeight=document.body.clientWidth;
                if(screenHeight>415){
                    this.seen=true;
                }else{
                    this.seen=false;
                }
            },
        },
        mounted() {
            this.menuSeen();
            this.sliders = [
                {
                    img: require('../../static/banner.png')
                },
            ]
            // window.addEventListener('resize', () => {
            //     location.reload();
            // });
        },
        computed: {
            //计算高度
            computeHeight() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 415) {
                    return '47vw';
                } else {
                    return '47vw';
                }
            },

        },
    }
</script>

<style scoped>
    .middle_li {
    transition: all 0.5s; 
    }
    .middle_li:hover {
    transform: scale(1.1); 
    }
    .bg-blue {
        background: #FFFFFF;
box-shadow: 0px 0 11px 0px rgba(164,164,164,0.15);
border-radius: 6px 6px 6px 6px;
    }
    .bg-blue:hover {
    background: rgba(22,109,209,0.8);
box-shadow: 0px 0 11px 0px rgba(164,164,164,0.15);
border-radius: 6px 6px 6px 6px;
    }

    .active1 {
        display: flex;
        align-items: center;
        width: 80%;
        margin-top: 2vh;
        padding: 2vh 1vw;
        box-sizing: border-box;
        background: linear-gradient(to right,#2FA2DC,#31DDBD);;
        color: #fff;
        border-radius: 10px;
        cursor: pointer;
    }
    .unActive1 {
        display: flex;
        align-items: center;
        width: 80%;
        margin-top: 2vh;
        padding: 2vh 1vw;
        box-sizing: border-box;
        background: #D6ECF9;
        color: #111;
        border-radius: 10px;
        cursor: pointer;
    }

    .border_parent {
        width: 90%;
        margin: auto;
    }

    .slider_img {
        height: 47vw;
        width: 100vw;
    }

    .solve {
        margin-top: 30px;
        margin-bottom: 10px
    }

    .border {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        height: auto;
        margin: 10px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
    }

    .border_one {
        margin-left: 0;
    }

    .border_img_parent {
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }

    .product_mobile_content {
        height: 300px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .product_mobile_img {
        width: 50%;
    }

    .product_mobile_title {
        font-weight: bold;
        text-align: center;
    }

    .product_pc_one {
        text-align: center;
        min-height: 400px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .font_size_30 {
        font-size: 1.875em;
    }

    .product_font_style {
        font-size: 1.125em;
    }

    .product_pc_img {
        width: 100%
    }

    .product_pc_img_div {
        width: 50%;
        float: left;
        display: flex;
        align-items: center;
    }

    .product_pc {
        display: flex;
        width: 90%;
        margin: 20px auto;
        background: #F2F6FC;
        align-items: center;
    }

    .product_spec_title {
        margin-top: 30px;
        margin-bottom: 10px
    }

    .product_spec_parent {
        display: flex;
        width: 90%;
        margin: 20px auto;
        align-items: center;
        height: auto
    }

    .cooperation_parent {
        display: flex;
        justify-content: center;
        width: 90%;
        margin: 20px auto;
        align-items: center;
        height: auto
    }

    .border_spec {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        float: left;
        width: 25%;
        height: auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }

    .about_me_p {
        font-size: 1.25em;
        font-weight: normal;
        padding: 0 20px;
        margin: 10px;
    }

    .border_title {
        font-family: "PingFang SC";
        margin-top: 10px;
        font-size: 1.125em;
        font-weight: bold;
        text-align: center;
    }

    .border_content_one {
        margin-top: 20px;
        font-size: 1.125em;
        text-align: center;
    }

    .border_content_two {
        margin-top: 5px;
        font-size: 1.125em;
        margin-bottom: 25px;
        text-align: center;
    }

    .img_border {
        margin-top: 15px;
        width: 80px;
        height: 80px
    }

    .border_spec_inner_one {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 35px;
        height: 70px;
    }

    .border_spec_content_one {
        margin-top: 15px;
        font-size: 1.125em;
        float: left;
        text-align: center;
    }

    .border_spec_inner_last {
        margin-top: 15px;
        font-size: 1.125em;
        float: left;
        margin-bottom: 25px;
        text-align: center;
    }

    .cooperation {
        margin-top: 30px;
        width: 100%;
    }

    .about_me {
        display: flex;
        margin-top: 30px;
        justify-content: center;
        width: 100%;
    }

    .product_mobile {
        width: 90%;
        align-items: center;
        margin: 20px auto;
        background: #F2F6FC;
    }

    .product_mobile_img_div {
        width: 50%;
        height: auto;
    }

    .product_mobile_content_one {
        margin-top: 20px;
        text-align: center;
    }

    .product_mobile_content_two {
        margin-top: 10px;
        text-align: center;
    }

    /* 屏幕设备适配 max-device-width: 400px */
    @media screen and (max-device-width: 415px) {
        .slider_img {
            height: 47vw;
            width: 100vw;
        }


        .border_parent {
            display: flex;
            width: 90%;
            margin: auto;
            height: auto;
            flex-direction: column;
        }

        .border {
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            float: left;
            width: 100%;
            height: auto;
            margin: 10px 0 auto;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
            /*background: aquamarine;*/
        }

        .border_img_parent {
            margin-top: 0;

        }

        .product_mobile {
            width: 90%;
            align-items: center;
            margin: 20px auto;
            height: auto;
            background: #F2F6FC;
        }

        .product_mobile_content {
            width: 100%;
            margin-top: 15px;
        }

        .product_mobile_content_one {
            margin-top: 5px;
        }

        .product_mobile_content_two {
            margin-top: 5px;
        }

        .product_mobile_img_div {
            display: flex;
            width: 100%;
            height: auto;
            justify-content: center;
            margin-top: 10px;
            margin-bottom: 15px;
        }

        .product_mobile_img {
            float: left;
        }

        .product_mobile_title {
            font-weight: bold;
        }

        .product_pc_one {
            width: 100%;
            margin-top: 15px;
        }

        .font_size_30 {
            font-size: 1.25em;
        }

        .product_font_style {
            font-size: 1em;
        }

        .product_pc_img {
            height: 280px;
            width: 320px;
        }

        .product_pc_img_div {
            width: 100%;
            float: left;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 15px;
        }

        .product_pc {
            display: flex;
            width: 90%;
            height: auto;
            margin: 20px auto;
            background: #F2F6FC;
            flex-direction: column;
        }

        .head-label {
            display: flex;
            margin-top: 10px;
        }

        .product_spec_parent {
            display: flex;
            width: 90%;
            align-items: center;
            justify-content: center;
            margin: 20px auto;
            height: auto;
            flex-direction: column;
        }

        .border_spec {
            float: left;
            height: auto;
            margin: 8px;
            width: 100%;
            border-radius: 6px;
            border: 1px solid #EBEEF5;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        }


        .border_title {
            font-family: "PingFang SC";
            margin-top: 5px;
            font-size: 1.125em;
            font-weight: bold;
        }

        .border_content_one {
            margin-top: 5px;
            font-size: 1.125em;
        }

        .border_content_two {
            margin-top: 5px;
            font-size: 1.125em;
            margin-bottom: 8px;
        }

        .img_border {
            margin-top: 8px;
            width: 80px;
            height: 80px
        }

        .border_spec_inner_one {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 8px;
            /*background-color: aqua;*/
            height: 70px;
        }

        .border_spec_content_one {
            margin-top: 5px;
            font-size: 1.125em;
            float: left;
        }

        .border_spec_inner_last {
            /*background-color: bisque;*/
            margin-top: 5px;
            font-size: 1.125em;
            float: left;
            margin-bottom: 8px;
        }

        .about_me {
            display: flex;
            margin-top: 10px;
            width: 100%;
        }
    }

    .border_spec_img {
        width: 75px;
        height: 55px;
        align-self: center
    }

    .font_size_24 {
        font-size: 1.5em;
    }
</style>